module.exports = __webpack_public_path__ + "static/media/haccp-96x96.ec3700e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/haccp-96x96.jpg
// module id = 1435
// module chunks = 0